(ns common.ocp.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Drawer$default" :as Drawer]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.ocp.db]
            [common.util :refer [spread-props]]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]])
  (:require-macros [common.ocp.view]))

(defui ocp-root
  []
  (let [{:keys [width position content id elevated-z-index]
         :or {width "25%"
              position "right"}} (use-subscribe [:ocp/current])
        props (use-subscribe [:ocp/props])]
    ($ Drawer
       {;; ID for tests, TODO: move tests to use testid?
        :id "off-canvas"
        :data-testid "off-canvas"
        :anchor position
        :variant "temporary"
        :open (use-subscribe [:ocp/open?])
        :onClose #(rf/dispatch [:ocp/close])
        :sx (when elevated-z-index
              (fn [^js theme]
                #js {:zIndex (+ (.. theme -zIndex -modal) 1)}))
        :PaperProps #js {:elevation 3
                         :data-testid (let [id* (cond
                                                  (qualified-keyword? id) (str (namespace id) "-" (name id))
                                                  (simple-keyword? id) (name id)
                                                  :else id)]
                                        (str id* "-off-canvas"))
                         :sx #js {:width (or (:width props) width)
                                  ;; Disable linearGradient
                                  :backgroundImage "none"
                                  :borderRadius 0}}
        :SlideProps #js {:onExited (fn [_e]
                                     ;; Clear the props after exit transition is done, to prevent changing the
                                     ;; panel contents during the transition.
                                     (rf/dispatch [:ocp/closed]))}}
       ;; The panel is selected until onExited is triggered, so the
       ;; content is visible until transition is done.
       (when content
         ($ @content props)))))

(defui ocp
  [{:keys [title header footer submenu on-submit on-close children]}]
  (let [{:keys [disable-padding disable-form background-color]
         :or {disable-form false
              background-color "grey.90"}} (use-subscribe [:ocp/current])]
    ($ Stack
       (spread-props {:flex 1
                      :direction "column"
                      :sx #js {:overflow "hidden"}}
                     (when-not disable-form
                       {:component "form"
                        :onSubmit (fn [e]
                                    (.preventDefault e)
                                    (when on-submit (on-submit)))}))
       ($ Stack
          {:direction "row"
           :alignItems "center"
           :sx #js {:backgroundColor background-color
                    :py 2
                    :px 3}}
          ($ Box
             {:data-component :off-canvas__title}
             ($ Typography
                {:variant "h2"
                 :data-testid "ocp-title"}
                title))
          ($ Box
             {:flexGrow 1})
          submenu
          ($ IconButton
             {:onClick (or on-close #(rf/dispatch [:ocp/close]))
              :data-testid "ocp-close-button"}
             ($ Icon "close")))
       (when header
         header)
       ($ Stack
          {:direction "column"
           :flex 1
           :spacing 3
           :sx #js {:overflow "auto"
                    :p (when-not disable-padding
                         3)}}
          children)
       (when footer
         ($ Stack
            {:direction "column"
             :spacing 1
             :sx #js {:px 3
                      :py 3}
             :alignItems "stretch"}
            footer)))))
